import {IAbstractModule, IModuleType} from "@/model/Locker/IModule";

export const ModuleZ4compC: IAbstractModule = {
  type: IModuleType.Z4compC,
  name: 'Z 4 compartment C (cascos)',
  hasScreen: false,
  columns: [
    [
      {
        name: "1",
        connector: "1",
        cell_size_id: 5,
        accessible: false,
      },
      {
        name: "2",
        connector: "2",
        cell_size_id: 5,
        accessible: true,
      },
      {
        name: "3",
        connector: "3",
        cell_size_id: 5,
        accessible: true,
      },
      {
        name: "4",
        connector: "4",
        cell_size_id: 5,
        accessible: false,
      },
    ],
  ]
};
